import { useState } from "react";

import * as S from "./styled";
import {
  Paragraph,
  Tooltip,
  TooltipButton,
  Text,
} from "@smartsuite/react-ui/lib";
import { GrayColors } from "@smartsuite/types";

const InformationTooltip: React.FC<{
  tooltipText: string;
  onClick?: () => void;
}> = ({ children, tooltipText, onClick = () => {} }) => {
  const [isDisplayed, setIsDisplayed] = useState(false);
  return (
    <S.Container>
      <Paragraph color={isDisplayed ? "tertiary" : "secondary"} size="xs">
        {children}
      </Paragraph>
      <Tooltip
        padding={2}
        placements={["right"]}
        maxWidth={250}
        onTooltipShow={(show) => {
          setIsDisplayed(show);
        }}
        target={
          <TooltipButton
            iconName="info-filled"
            iconSize="S"
            colors={{
              default: GrayColors["G-3"],
              hover: GrayColors["G-8"],
            }}
            handleClick={onClick}
          />
        }
        renderTooltipContent={
          <Text color="reverse" size="xs" weight="semibold" align="left">
            {tooltipText}
          </Text>
        }
      />
    </S.Container>
  );
};

export { InformationTooltip };
